const VERSION = '2026-10-07-v1';
const RULES = ['Hakaret, taciz, tehdit, nefret söylemi ve kişisel bilgi ifşası yasaktır.',
  'Profil adı ve fotoğrafında cinsel, şiddet içeren veya başkasını taklit eden içerik kullanma.',
  'Spam gönderme. Uygunsuz içeriği bildir; oyuncuları engelleyebilir ve karara destek adresinden itiraz edebilirsin.',
  'İhlal eden içerik kaldırılabilir; gerekçeli ve süreli sohbet kısıtlaması uygulanabilir.'];
module.exports = { VERSION, RULES };
